<style lang="less" rel="stylesheet/less" scope>
  @import url('./../css/common.less');
</style>
<template>
  <div class="login-wrapper" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.2)">
    <div v-show="!isLoading">
      <header>
        <span class="header-img">
          <img v-if="competentData.logoImgUrl" :src="BASE_API + competentData.logoImgUrl" alt="" id="img1"/>
          <img v-if="competentData.showDefaultHeader" src="./../../../assets/login/header.jpg" alt=""/>
        </span>
      </header>
      <section ref="section">
        <el-row class="main-row">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :offset="2">
            <div class="img-box" id="img-box" v-on:mouseenter="visible" @mouseleave="display">
              <img v-if="competentData.centerImgUrl" :src="BASE_API + competentData.centerImgUrl" alt=""/>
              <img v-if="competentData.showDefaultCenter" src="./../../../assets/login/login-default.jpg" alt=""/>
              <div class="rule" v-show="seen" v-if="rule">
                <p>{{rule.p1}}</p>
                <p>{{rule.p2}}</p>
                <p>{{rule.p3}}</p>
                <p>{{rule.p4}}</p>
                <p>{{rule.p5}}</p>
                <ul>
                  <li>{{rule.p6}}</li>
                  <li>&nbsp&nbsp{{rule.tel_1}}&nbsp&nbsp&nbsp&nbsp&nbsp{{rule.tel_2}}</li>
                  <li>{{rule.time}}</li>
                </ul>
              </div>
            </div>
          </el-col>
          <el-col :xs="6" :sm="6" :md="5" :lg="5" :offset="2">
            <login-board-normal ref="login"></login-board-normal>
          </el-col>
        </el-row>
      </section>
      <footer class="effect">
        <ul>
          <li>
            <span v-show="competentData.sponsoringDept">主管部门：
              <a class="info" :href='competentData.sponsoringDeptLink' :class="{'foot-hover':competentData.sponsoringDeptLink}" target="_blank">{{competentData.sponsoringDept}}</a>
            </span>
            <span v-show="competentData.competentOgn">主办单位：
              <a class="info" :href='competentData.competentOgnLink'  :class="{'foot-hover':competentData.competentOgnLink}" target="_blank">{{competentData.competentOgn}}</a>
            </span>
          </li>
          <li>
            <span class="other-item" v-if="otherConfig.name">
              <img :src="otherConfig.img" alt="图标"/>
               <span>{{otherConfig.name}}：</span>
               <a class="info" :href='otherConfig.link'  :class="{'foot-hover':otherConfig.link}" target="_blank">{{otherConfig.company}}</a>
            </span>
            <span class="footer-item techSupport" v-show="competentData.techSupport">技术支持：
               <a class="info" :href='competentData.techSupportLink'  :class="{'foot-hover':competentData.techSupportLink}" target="_blank">{{competentData.techSupport}}</a>
            </span>
            <span class="footer-item customerTelephone" v-show="competentData.customerTelephone">客服电话：
              <a target="_blank">{{competentData.customerTelephone}}</a>
            </span>
            <span class="other-item" v-if="otherConfig&&otherConfig.webNumber">网站备案号：{{otherConfig.webNumber}}</span>
          </li>
        </ul>
      </footer>
      <ly-customer-board class="customer"></ly-customer-board>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import loginBoardNormal from './login-normal.vue'
  import fallbackImage from './../fallback-image.vue'
  import { getIndex } from '@/api/login'
  export default {
    name: 'login',
    components: {
      loginBoardNormal,
      fallbackImage
    },
    data () {
      return {
        loading: true,
        isLoading: true,
        BASE_API: this.$store.getters.objApi.BASE_API,
        competentData: {
          showDefaultCenter: false,
          showDefaultHeader: false
        },
        active: 0,
        seen:false
      }
    },
    computed: {
      imgCarousel() {
        return this.competentData.centerImgUrl ? this.competentData.centerImgUrl.split(',') : [];
      },
      otherConfig() {
        return this.$store.getters.objApi.otherConfig
      },
      rule(){
        return this.$store.getters.objApi.rule
      }
    },
    created() {
      this.getIndex();
    },
    mounted() {
      this.$nextTick(() => {
        setTimeout(()=>{
          this.loadImg();
          window.onresize = () => {
            this.setLogin();
          };
        },0);
        setTimeout(() => {
          this.loading = false;
          this.isLoading = false;
        }, 100)
      })
    },
    methods: {
      visible:function () {
        this.seen=true;
      },
      display:function () {
        this.seen=false;
      },
      setLogin() {
//        let $login = this.$refs.login.$el;
//        $login.setAttribute('style', 'height:' + (this.$refs.section.clientHeight - 56) + 'px');
      },
      loadImg() {
        let _this = this;
        // document.getElementById('img1').onload = () => {
        //   _this.setLogin();
        //   _this.isLoading = false;
        //   _this.loading = false;
        // }
      },
      getIndex() {
        getIndex().then(res => {
          this.competentData = res.data;
          if(!this.competentData.centerImgUrl){
            this.competentData.showDefaultCenter = true;
          }
          if(!this.competentData.logoImgUrl){
            this.competentData.showDefaultHeader = true;
          }
          this.isLoading = false;
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/login/components/index-normal.vue